import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { fluxSurfaceBorder } from "../flux/variants.js";
export function Composer({ children, footer, actions, className = "", ...rest }) {
    return (_jsxs("div", { className: [
            "grid gap-2 rounded-2xl bg-white p-2 shadow-xs ring-1 ring-black/[0.07]",
            fluxSurfaceBorder,
            className,
        ].join(" "), ...rest, children: [_jsx("div", { className: "min-w-0", children: children }), (footer || actions) && (_jsxs("div", { className: "grid grid-cols-[minmax(0,1fr)_auto] items-center gap-2 px-1 pb-1", children: [_jsx("div", { className: "min-w-0 text-sm text-zinc-500", children: footer }), actions ? _jsx("div", { className: "flex items-center gap-1", children: actions }) : null] }))] }));
}
export const ComposerTextarea = React.forwardRef(({ className = "", ...rest }, ref) => {
    return (_jsx("textarea", { ref: ref, className: [
            "min-h-[3rem] w-full resize-none border-0 bg-transparent px-2 py-1.5",
            "text-base text-zinc-800 placeholder-zinc-400 outline-none sm:text-sm",
            className,
        ].join(" "), ...rest }));
});
ComposerTextarea.displayName = "ComposerTextarea";
